module.exports = __webpack_public_path__ + "static/keg_robot-7913197ee0f6649645c9ef668587c866.png";